module.exports = __webpack_public_path__ + "static/media/ep3.4115ca0a.jpg";